/**
 * The prop catalogue.
 *
 * Shared rather than client-side because a prop's hull is simulation input: a
 * hider who possesses a crate moves with the crate's dimensions, and the client
 * predicts that movement while the server decides it. A disagreement of one
 * centimetre here is a hider who rubber-bands from the instant they disguise.
 *
 * Constraints the validator enforces, repeated here because they are easy to
 * violate while eyeballing plausible numbers:
 *
 *  - Footprints are square (`halfWidth === halfDepth`). Collision is
 *    axis-aligned and does not rotate with the mesh, so an oblong prop would
 *    collide differently than it draws once it is turned.
 *  - No dimension below MIN_SOLID_THICKNESS (0.5m). A prop is a solid, and a
 *    solid thinner than a collision sub-step is one players tunnel through.
 *
 * Ids are wire identity and must never be renumbered — a snapshot carries the
 * id, not the name. Append; do not reorder. Id 0 is reserved for "an
 * undisguised player".
 */

import { propCatalogue, type PropDef } from "./mapfmt.js";

export const PROP_DEFS: readonly PropDef[] = [
  { id: 1, label: "crate", hull: { halfWidth: 0.5, halfDepth: 0.5, height: 1.0 }, mesh: "crate" },
  { id: 2, label: "barrel", hull: { halfWidth: 0.35, halfDepth: 0.35, height: 0.95 }, mesh: "barrel" },
  { id: 3, label: "small crate", hull: { halfWidth: 0.3, halfDepth: 0.3, height: 0.6 }, mesh: "crate_small" },
  { id: 4, label: "traffic cone", hull: { halfWidth: 0.25, halfDepth: 0.25, height: 0.65 }, mesh: "cone" },
  { id: 5, label: "potted plant", hull: { halfWidth: 0.4, halfDepth: 0.4, height: 1.4 }, mesh: "plant" },
  { id: 6, label: "pallet stack", hull: { halfWidth: 0.6, halfDepth: 0.6, height: 0.55 }, mesh: "pallet" },
];

export const PROP_CATALOGUE = propCatalogue(PROP_DEFS);
